export default "__VITE_ASSET__c9792558__"